import {
  ArrowDownIcon,
  ArrowUpIcon,
  IconButton,
  IconButtonColorEnum,
  IconButtonSizeEnum,
  IconSizeEnum,
  IndeterminateIcon,
  TrashDeleteIcon,
} from '@acceso/design-system';

import { formatDateCustom } from '@/helpers/format-date';
import { EVisibility } from '@/types/types';

import { TimeKeepingRecords } from '../types';

type TimeKeepingSupportRecordProps = {
  compositeId: string;
  supportPresenceId: string;
  record: TimeKeepingRecords;
  idx: number;
  isActive?: boolean;
  playerVideoCurrentTime?: number;
  getDateTimeCurrentPresence?: (time: number) => Date | null | undefined;
  onRemove: (compositeId: string, supportPresenceId: string, recordIndex: number) => void;
  onToggleVisibility: (
    compositeId: string,
    supportPresenceId: string,
    recordIndex: number,
    currentVisibility: EVisibility,
    el: HTMLElement
  ) => void;
};

export function TimeKeepingSupportRecord({
  compositeId,
  supportPresenceId,
  record,
  idx,
  isActive = false,
  playerVideoCurrentTime,
  getDateTimeCurrentPresence,
  onRemove,
  onToggleVisibility,
}: TimeKeepingSupportRecordProps) {
  const endValue = (() => {
    if (
      isActive &&
      record.datetimeEnd === '0' &&
      getDateTimeCurrentPresence !== undefined &&
      playerVideoCurrentTime !== undefined
    ) {
      return getDateTimeCurrentPresence(playerVideoCurrentTime) ?? new Date();
    }
    return record.datetimeEnd;
  })();

  return (
    <div className="flex items-center gap-2 px-2 py-1.5 text-[11px] hover:bg-neutral-10">
      <div className="mr-2 shrink-0" data-id="record-visibility">
        <IconButton
          color={IconButtonColorEnum.NONE_PRIMARY}
          size={IconButtonSizeEnum.XS}
          onClick={e =>
            onToggleVisibility(
              compositeId,
              supportPresenceId,
              idx,
              record.visibility,
              e.currentTarget
            )
          }
          onPointerDown={e => e.stopPropagation()}
          className="mt-0.5 min-h-4 min-w-4 shrink-0"
        >
          {record.visibility === EVisibility.ALTA && <ArrowUpIcon size={IconSizeEnum['2XS']} />}
          {record.visibility === EVisibility.MEDIA && (
            <IndeterminateIcon size={IconSizeEnum['2XS']} />
          )}
          {record.visibility === EVisibility.BAJA && <ArrowDownIcon size={IconSizeEnum['2XS']} />}
        </IconButton>
      </div>
      <span className="flex-1 break-all">
        {formatDateCustom({ input: record.datetimeStart, format: 'HH:mm:ss' })}
      </span>
      <span className="flex-1 break-all">
        {formatDateCustom({ input: endValue, format: 'HH:mm:ss' })}
      </span>
      <IconButton
        color={IconButtonColorEnum.NONE_PRIMARY}
        size={IconButtonSizeEnum.MD}
        onClick={() => onRemove(compositeId, supportPresenceId, idx)}
      >
        <TrashDeleteIcon size={IconSizeEnum.SM} />
      </IconButton>
    </div>
  );
}
